import { type Node as PMNode } from '@atlaskit/editor-prosemirror/model';

import { getActualTextContent } from './getActualTextContent';

export const getActualTextContentLength = (doc: PMNode): number => {
	const actualTextContent = getActualTextContent(doc);
	return actualTextContent.trim().length;
};
